interface ProductCardProps {
	title: string;
	description: string;
	imageSrc: string;
	price: string;
	duration: string;
	buttonText: string;
	soldOut?: boolean;
	onClick?: () => void;
}

export const ProductCard = ({
	title,
	description,
	imageSrc,
	price,
	duration,
	buttonText,
	soldOut = false,
	onClick,
}: ProductCardProps) => {
	return (
		<div className='flex flex-col bg-white rounded-3xl overflow-hidden shadow-md relative min-h-[560px]'>
			<div className='absolute inset-0'>
				<img
					src={imageSrc}
					alt={title}
					className='h-full w-full object-cover'
				/>
			</div>

			<div className='absolute bottom-0 left-0 right-0 bg-white rounded-t-3xl p-6'>
				<h3 className='text-lg font-bold text-neutral-800 capitalize'>
					{title}
				</h3>
				<p className='text-neutral-600 text-sm mt-2'>{description}</p>

				<div className='flex items-center justify-between mt-4'>
					<div className='flex flex-col'>
						<span className='text-xs text-neutral-500'>Duration</span>
						<span className='text-neutral-800 font-semibold'>{duration}</span>
					</div>
					<div className='flex flex-col text-right'>
						<span className='text-xs text-neutral-500'>Price</span>
						<span className='text-neutral-800 font-bold'>{price}</span>
					</div>
				</div>

				<button
					className={`w-full mt-4 py-2 px-4 rounded-full text-center font-bold text-sm ${
						soldOut
							? 'bg-neutral-200 text-neutral-500'
							: 'bg-[#FBB040] text-neutral-800 hover:bg-[#FBB040]/80'
					}`}
					disabled={soldOut}
					onClick={onClick}
				>
					{buttonText}
				</button>
			</div>
		</div>
	);
};
